export default "__VITE_ASSET__DLm0peBY__"